import styled from '@emotion/styled';
import { ChangeEvent, FormEvent, forwardRef, memo } from 'react';

import { ChatInput } from './ChatInput';

interface ChatFooterProps {
    input: string;
    handleInputChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
    handleSubmit?: (e?: FormEvent<HTMLFormElement>) => void;
}

const FooterRef = styled.div`
    padding: ${({ theme }) => theme.spacing.md};
    padding-top: ${({ theme }) => theme.spacing.xs};
    background: ${({ theme }) => theme.palette.background.default};
`;

const ChatFooter = forwardRef<HTMLDivElement, ChatFooterProps>(
    ({ input, handleInputChange, handleSubmit }, ref) => {
        return (
            <FooterRef ref={ref}>
                <ChatInput
                    value={input}
                    handleInputChange={handleInputChange}
                    handleSubmit={handleSubmit}
                />
            </FooterRef>
        );
    }
);

ChatFooter.displayName = 'ChatFooter';

export default memo(ChatFooter);
